var React = require('react');

function PhysicalComfort (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("line",{"className":"cls-1","y1":"67.44","x2":"68.03","y2":"67.44","key":0}),React.createElement("path",{"className":"cls-1","d":"M0,52.17c17.01,0,17.01,7.41,34.02,7.41s17.01-7.41,34.02-7.41","key":1}),React.createElement("path",{"className":"cls-1","d":"M68.03,35.1c-17.01,0-17.01,16.37-34.02,16.37S17.01,35.1,0,35.1","key":2}),React.createElement("circle",{"className":"cls-1","cx":"34.02","cy":"14.74","r":"13.84","key":3})])]);
}

PhysicalComfort.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 68.03 68.34"};

module.exports = PhysicalComfort;

PhysicalComfort.default = PhysicalComfort;
